/**
 * Fades and eases each section's text, images, and buttons into view the
 * first time it scrolls into the viewport. Progressive enhancement: the
 * `js-reveal-ready` class that unlocks the hidden starting state (see
 * scroll-reveal.css) is only added once this script actually runs, so
 * content is never left invisible if it fails to load.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var sections = main.querySelectorAll('.shopify-section');
  if (!sections.length) return;

  document.documentElement.classList.add('js-reveal-ready');

  var ITEM_SELECTOR = '.text-block, img, video, .button, .button-secondary, .price';
  var DELAY_STEP_MS = 70;
  var MAX_DELAY_MS = 280;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  sections.forEach(function (section) {
    section.setAttribute('data-reveal', '');

    section.querySelectorAll(ITEM_SELECTOR).forEach(function (item, index) {
      item.setAttribute('data-reveal-item', '');
      item.style.setProperty('--reveal-delay', Math.min(index * DELAY_STEP_MS, MAX_DELAY_MS) + 'ms');
    });

    observer.observe(section);
  });
})();
